import { isAxiosError } from "axios";
/**
 * Extracts the backend's own error message (envelope `{ message, error,
 * statusCode }`) instead of showing a generic fallback for every failure —
 * validation errors (file type, size, etc.) need to reach the user verbatim.
 */
export function getApiErrorMessage(error, fallback) {
    var _a, _b;
    if (isAxiosError(error)) {
        var message = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
        if (typeof message === "string" && message.trim().length > 0) {
            return message;
        }
    }
    return fallback;
}
